module.exports = __webpack_public_path__ + "img/BMWM1.5f54e9bb.jpeg";